import React, { memo } from "react";
//@ts-ignore
import accounting from "accounting";
import getSymbolFromCurrency from "currency-symbol-map";

interface Props {
	amount: string | number;
	currency?: string;
	showCurrency?: boolean;
	decimals?: number;
}

const Money = ({ amount, showCurrency = false, currency = "AUD", decimals = 2 }: Props) => (
	<span {...{ className: "money", "data-currency": currency, "data-amount": `${amount}` }}>
		{accounting.formatMoney(
			accounting.toFixed(parseFloat(`${amount}`) / 100, 2),
			{
				symbol: getSymbolFromCurrency(currency),
				format: {
					pos: "%s%v",
					neg: "-%s%v",
					zero: "%s%v"
				}
			},
			decimals
		)}
		{showCurrency && currency}
	</span>
);

export default memo(Money);
